import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

const demo = ['GREAT', 'RIDGE', 'EDGES', 'AGENT', 'TESTS']

export const InfoModal = ({ isOpen, handleClose }: Props) => (
  <BaseModal title="How to play" isOpen={isOpen} handleClose={handleClose}>
    <div className="how-to-layout">
      <div className="how-to-example">
        <p className="how-to-intro">
          Make five words that read the same <strong>across and down</strong>.
        </p>

        <div className="mini-square" aria-label="Completed word square example">
          {demo
            .join('')
            .split('')
            .map((letter, index) => (
              <span key={index}>{letter}</span>
            ))}
        </div>
      </div>

      <ol className="how-to-steps">
        <li>
          <span className="rule-number" aria-hidden="true">
            1
          </span>
          <p>
            <strong>Place letters</strong>
            <span>Tap a tile and type. Tap again to replace.</span>
          </p>
        </li>
        <li>
          <span className="rule-number" aria-hidden="true">
            2
          </span>
          <p>
            <strong>Check a row</strong>
            <span>A correct row locks and reveals crossings.</span>
          </p>
        </li>
        <li>
          <span className="rule-number" aria-hidden="true">
            3
          </span>
          <p>
            <strong>Use a hint</strong>
            <span>
              A hint reveals a matching pair when both tiles are open.
            </span>
          </p>
        </li>
        <li>
          <span className="rule-number" aria-hidden="true">
            4
          </span>
          <p>
            <strong>Keep playing</strong>
            <span>Boards save here; practice is unlimited.</span>
          </p>
        </li>
      </ol>
    </div>

    <div className="marker-key" aria-label="Tile markers">
      <span>
        <i className="legend-swatch legend-swatch--clue" aria-hidden="true">
          C
        </i>
        Clue
      </span>
      <span>
        <i className="legend-swatch legend-swatch--cross" aria-hidden="true">
          +
        </i>
        Crossing
      </span>
      <span>
        <i className="legend-swatch legend-swatch--hint" aria-hidden="true">
          H
        </i>
        Hint
      </span>
    </div>

    <div className="feedback-key" aria-label="Guess feedback">
      <span>
        <i className="feedback-tile feedback-tile--correct">✓</i>Right
      </span>
      <span>
        <i className="feedback-tile feedback-tile--present">↔</i>Elsewhere
      </span>
      <span>
        <i className="feedback-tile feedback-tile--absent">×</i>Absent
      </span>
    </div>

    <button className="how-to-button" onClick={handleClose}>
      Start solving
    </button>
  </BaseModal>
)
